/**
 * The language of a country, for whoever writes texts that reach its leads.
 *
 * The CRM stays in Italian, the operators' language, but an AI agent speaks
 * the language of its country (`country.languageTag`, e.g. 'de-DE'): every
 * text the admin writes for the agent, sent word for word or read by the
 * model, has to be written in it.
 */

/**
 * A readable name for a languageTag, in the CRM's language: 'de-DE' reads
 * "tedesco (Germania)". Falls back on the raw tag where the browser has no
 * Intl.DisplayNames or the tag is not one it can read, and is null without a
 * tag.
 */
export const languageName = (languageTag, locale = 'it') => {
  if (!languageTag) return null;
  const tag = String(languageTag).replace(/_/g, '-');
  try {
    if (typeof Intl === 'undefined' || !Intl.DisplayNames) return tag;
    return new Intl.DisplayNames([locale], { type: 'language' }).of(tag) || tag;
  } catch (error) {
    return tag;
  }
};

/** The help line that says which language to write a text in. */
export const writeInCountryLanguage = (t, languageTag) => {
  const language = languageName(languageTag);
  return language
    ? t(
        'Write it in {{language}}, the language of the leads of this country.',
        { language },
      )
    : t('Write it in the language of the leads of this country.');
};
